require('@expo/metro-runtime');
const { Platform } = require('react-native');
// expo-dev-client is only used for native (dev builds); web uses Metro + React Native Web and does not load this module.
if (Platform.OS !== 'web') {
  require('expo-dev-client');
  // FCM/notifee background handlers must register at module scope, before the tree mounts.
  require('./src/libs/notifications/register-background-handlers').registerBackgroundHandlers();
}
const { registerRootComponent } = require('expo');
const App = require('./App').default;

// Mirror every console call into the in-app debug ring buffer so testers can
// export it from the profile long-press panel. Replaces the old prod-only
// `console.* = () => {}` stubbing: in production the native console stays silent
// (for perf) while entries are still retained in the buffer; in dev the native
// console is untouched.
require('./src/libs/debug-log/console-capture').installConsoleCapture();

registerRootComponent(App);
